import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CoreStore } from '@core/store/core.store';
import { userRetrieved$ } from '@core/store/core-store.utils';

/** The authenticated user must not reach the login page: back to the dashboard. */
export const guestGuard: CanMatchFn = (): Observable<boolean | UrlTree> => {
  const coreStore = inject(CoreStore);
  const router = inject(Router);

  return userRetrieved$().pipe(
    map(() => !coreStore.isLogged() || router.createUrlTree(['']))
  );
};